export function getEmailField(data) {
    const emailField = Array.from(data).filter(
        (field) => field.type === "email" 
        || field.dataset.mappedField?.toLowerCase().indexOf("email") >= 0 
    );
    
    return emailField.length > 0 ? emailField[0] : null;
}

export function getTelField(data) {
    const phoneField = Array.from(data).filter(
        field => field.type === "tel"
        || field.dataset.mappedField?.toLowerCase().indexOf("phone number") >= 0 
    );
    return phoneField.length > 0 ? phoneField[0] : null;
}

export function getFieldByMappedField(data, mappedFieldName) {
    const mappedField = Array.from(data).filter(
        (field) => field.dataset.mappedField?.indexOf(mappedFieldName) >= 0 
    );
    return mappedField.length > 0 ? mappedField[0] : null;
}
